<template>
  <div>
    <h2>Incomplete submissions</h2>

    <v-data-table
      :headers="headers"
      :items="manuscripts"
      :items-per-page="10"
      class="elevation-1 mt-5"
    >
      <template v-slot:[`item.createdAt`]="{ item }">
        <small>{{ formatDate(item.createdAt) }}</small>
      </template>
      <template v-slot:[`item.folder`]="{ item }">
        {{ `JMESR/${String(item.folder).toUpperCase()}` }}
      </template>
      <template v-slot:[`item.authors`]="{ item }">
        {{ item.authors.length }} | {{ item.files.length }}
      </template>
      <template v-slot:[`item.user.firstName`]="{ item }">
        {{ item.user.title }} {{ item.user.firstName }}
        {{ item.user.lastName }} <br />
        <small>({{ item.user.institution }})</small>
      </template>
      <template v-slot:[`item.updatedAt`]="{ item }">
        <v-btn
          small
          outlined
          color="pink"
          class="my-1 mr-1"
          :to="`/editorial/incomplete/${item._id}`"
        >
          More Info
        </v-btn>
        <!-- :disabled="deleting" -->
        <!-- <v-btn
          small
          text
          disabled
          color="red"
          class="my-1 mr-1"
          @click="deleteManuscript(item._id)"
        >
          Delete
        </v-btn> -->
      </template>
    </v-data-table>
  </div>
</template>


<script>
import { formatDateOnly as formatDate } from "../../tools/format";

export default {
  data: () => ({
    loading: false,
    deleting: false,
    manuscripts: [],
    headers: [
      { text: "Started", value: "createdAt" },
      { text: "Manuscript ID", value: "folder" },
      { text: "Submitted By", value: "user.firstName" },
      {
        text: "Manuscript Title",
        align: "start",
        value: "title",
      },
      { text: "Manuscript Type", value: "type" },
      { text: "Authors | Files", align: "center", value: "authors" },
      // { text: "Uploaded", value: "files" },
      // { text: "Submission", value: "submissionStatus" },
      { text: "Actions", value: "updatedAt", sortable: false },
    ],
  }),
  methods: {
    formatDate,
    fetchSubmissions() {
      this.loading = true;
      this.$axios
        .get("/editorial/manuscripts/incomplete")
        .then(({ data: response }) => {
          this.manuscripts = response;
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not retrieve manuscripts",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteManuscript(id) {
      this.deleting = true;

      this.$axios
        .delete(`/editorial/manuscript/${id}`)
        .then(() => {
          this.$bus.$emit("manuscript.refresh");
          this.$bus.$emit("snackbar", {
            type: "info",
            message: "Manuscript deleted",
          });
          this.fetchSubmissions();
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not delete manuscript",
          });
        })
        .finally(() => {
          this.deleting = false;
        });
    },
  },
  mounted() {
    this.fetchSubmissions();
  },
};
</script>

<style>
</style>